// @ts-expect-error no types for this file
import SafeStorage from 'SafeStorage';
import { fromJS, Map as ImmutableMap } from 'immutable';
import PortalIdParser from 'PortalIdParser';
export const getLocalStorageValue = key => {
  try {
    const savedValue = SafeStorage.getItem(key);
    if (!savedValue) {
      return null;
    }
    return fromJS(JSON.parse(savedValue));
  } catch (e) {
    return null;
  }
};
export const getValueForPortalFromLocalStorage = (key, fallback) => {
  const portalId = PortalIdParser.get();
  if (!portalId) {
    return fallback;
  }
  const value = getLocalStorageValue(key) || ImmutableMap();
  const valueForPortal = value.get(portalId.toString(), fallback);
  return valueForPortal;
};
export const setValueInLocalStorage = (key, value) => {
  const portalId = PortalIdParser.get();
  const savedValue = getLocalStorageValue(key) || ImmutableMap();
  const newValue = savedValue.set(portalId, value);
  try {
    SafeStorage.setItem(key, JSON.stringify(newValue.toJS()));
  } catch (e) {
    return;
  }
};